export default __webpack_public_path__ + "static/media/edit-employees.509fe312.svg";